export default {
  setNotification (state, payload) {
    state.notification = payload
  }
}
